/* eslint-disable */
/**
 * TomTilstand — Stiplet boks, ikon, forklarende tekst, evt. handlingsknap
 *
 * BRUGES alle steder data mangler — aldrig 0/fake værdier.
 *
 * Props:
 *   titel       string  — hvad der mangler, fx "Facebook API"
 *   besked      string  — hvad der skal til, fx "Kræver META_ACCESS_TOKEN i .env"
 *   ikon        string  — emoji/unicode
 *   badge       'LIVE' | 'KONFIGURERET' | 'IKKE FORBUNDET' | 'OPMÆRKSOMHED' | 'FEJL'
 *   handling    string  — knap-label (undefined = ingen knap)
 *   onHandling  fn      — klik-handler til knappen
 *   style       obj
 */

import React from 'react';
import { BADGE_FV, TEKST, RADIUS, STATUS } from './tokens';

export default function TomTilstand({ titel, besked, ikon, badge = 'IKKE FORBUNDET', handling, onHandling, style = {} }) {
  const bf = BADGE_FV[badge] || BADGE_FV['IKKE FORBUNDET'];

  return (
    <div style={{
      display:       'flex',
      flexDirection: 'column',
      alignItems:    'center',
      justifyContent: 'center',
      textAlign:     'center',
      padding:       '36px 24px',
      gap:           12,
      background:    bf.bg,
      border:        `1px dashed ${bf.kant}`,
      borderRadius:  RADIUS.kort,
      ...style,
    }}>
      {ikon && (
        <span style={{ fontSize: 32, opacity: 0.45, lineHeight: 1 }}>{ikon}</span>
      )}

      <div>
        {titel && (
          <div style={{ fontSize: 14, fontWeight: 700, color: TEKST.primær, marginBottom: 5 }}>
            {titel}
          </div>
        )}
        {besked && (
          <div style={{ fontSize: 12, color: TEKST.sekundær, lineHeight: 1.6, maxWidth: 340 }}>
            {besked}
          </div>
        )}
      </div>

      {/* Badge */}
      <span style={{
        fontSize:     9,
        fontWeight:   700,
        padding:      '3px 10px',
        borderRadius: RADIUS.pill,
        background:   bf.bg,
        border:       `1px solid ${bf.kant}`,
        color:        bf.txt,
        textTransform: 'uppercase',
        letterSpacing: 0.8,
      }}>
        {badge}
      </span>

      {/* Handlingsknap */}
      {handling && onHandling && (
        <button
          onClick={onHandling}
          style={{
            marginTop:   4,
            background:  STATUS.konfigureret,
            color:       '#fff',
            border:      'none',
            borderRadius: RADIUS.knap,
            padding:     '6px 16px',
            fontSize:    12,
            fontWeight:  600,
            cursor:      'pointer',
          }}
          onMouseEnter={e => { e.currentTarget.style.opacity = '.82'; }}
          onMouseLeave={e => { e.currentTarget.style.opacity = '1'; }}
        >
          {handling}
        </button>
      )}
    </div>
  );
}
